import { createStore, applyMiddleware, compose, combineReducers } from 'redux'
import thunk from 'redux-thunk'
import storage from 'redux-persist/lib/storage'
import { persistReducer } from 'redux-persist'
import landingReducer from 'reducers/landingReducer'
import signupReducer from 'reducers/signUpReducer'
import passwordReducer from 'reducers/passwordReducer'
import authenticationReducer from 'reducers/authenticationReducer'
import menuReducer from 'reducers/menuReducer'
import cartReducer from 'reducers/cartReducer'
import loadingReducer from 'reducers/loadingReducer'
import checkoutReducer from 'reducers/checkoutReducer'
import businessReducer from 'reducers/businessReducer'
import settingsReducer from 'reducers/settingsReducer'
import gdprReducer from 'reducers/gdprReducer'
import teamVoucherReducer from 'reducers/teamVoucherReducer'
import linkVoucherReducer from 'reducers/linkVoucherReducer'
import deliveryTrackingReducer from 'reducers/deliveryTrackingReducer'
import taggedInputTextReducer from 'reducers/taggedInputTextReducer'
import invoiceReducer from 'reducers/invoiceReducer'

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

const signupPersistConfig = {
  key: 'signupPersist',
  storage: storage,
  whitelist: ['user']
}

const menuPersistConfig = {
  key: 'menuPersist',
  storage: storage,
  whitelist: ['listAddress', 'addresses', 'showCollectionOption', 'itemsSideBarMenu', 'restaurantsOptions']
}

const rootReducer = combineReducers({
  landingReducer: landingReducer,
  signupReducer: persistReducer(signupPersistConfig, signupReducer),
  passwordReducer: passwordReducer,
  authenticationReducer: authenticationReducer,
  menuReducer: persistReducer(menuPersistConfig, menuReducer),
  cartReducer: cartReducer,
  loadingReducer: loadingReducer,
  checkoutReducer: checkoutReducer,
  businessReducer: businessReducer,
  settingsReducer: settingsReducer,
  gdprReducer: gdprReducer,
  teamVoucherReducer: teamVoucherReducer,
  linkVoucherReducer: linkVoucherReducer,
  deliveryTrackingReducer: deliveryTrackingReducer,
  taggedInputTextReducer: taggedInputTextReducer,
  invoiceReducer: invoiceReducer
})

export default createStore(rootReducer, composeEnhancers(
  applyMiddleware(thunk)
))



// WEBPACK FOOTER //
// ./src/config/createStore.js